module.exports = __webpack_public_path__ + "assets/ais-pay.ca0937d6ab06cd39e89b91e9193eb639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ais-pay.jpg
// module id = 627
// module chunks = 0